import { CmsBrand } from '../Entities/CmsBrands/cmsbrands.reducer';
import actionCreatorFactory from 'typescript-fsa';
import { BrandImage } from '../../modules/BrandEdit/index';

const actionCreator = actionCreatorFactory('BrandEdit');

export const startLoading = actionCreator('CMS_BRAND_EDIT_LOADING_START');
export const stopLoading = actionCreator('CMS_BRAND_EDIT_LOADING_END');

export const setCmsBrand = actionCreator<{ cmsBrandId: Number }>(
  'CMS_BRAND_EDIT_SET'
);

export const editBrandFetched = actionCreator<{
  cmsBrand: CmsBrand;
}>('CMS_BRAND_EDIT_CMS_BRAND_FETCHED');

export const saveEditBrand = actionCreator<{
  images: BrandImage[];
  gender: string;
}>('CMS_BRAND_EDIT_SAVE');

export const resetBrandEdit = actionCreator('RESET');



// WEBPACK FOOTER //
// ./src/store/BrandEdit/brand-edit.actions.ts